export default __webpack_public_path__ + "static/media/080_finish_good.first.07f32f42.webp";